import { yupResolver } from '@hookform/resolvers/yup';
import { Grid, Box, styled } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useState } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import {
  IJobBoardDTO,
  IJobBoardShareAccountPayload,
  JobBoardShareAccount,
  shareJobBoardAccounts,
  usersAdvanceFilterQuery,
} from 'wisestep-api';
import { ControlledTextInput, Label, WsAutoComplete, WsButton } from 'wisestep-base';
import { string, object } from 'yup';

import { success, failed } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';

type PropTypes = {
  tableData: IJobBoardDTO;
  country?: string;
  dataIndex: number;
  dataUpdater(data: IJobBoardDTO, index: number);
  onClose(): void;
};
const BoldLabel = styled(Label)(() => ({
  fontWeight: 'bold',
}));
const validationSchema = object().shape({
  credits: string().required('Credits are required'),
});

const ShareQuota = ({ tableData, country, dataIndex, dataUpdater, onClose }: PropTypes) => {
  const [suggestionsData, setSuggestionData] = useState<string[]>([]);
  const [sEmail, setSEmail] = useState<string>('');
  const setNotification = useNotificationStore((state) => state.setNotification);

  const formOptions = {
    resolver: yupResolver(validationSchema),
  };

  const methods = useForm(formOptions);
  const { handleSubmit, reset } = methods;

  const onEmailSelect = (selectedEmail: string[]) => setSEmail(selectedEmail[0]);
  const workspaceRecruiterSearchAPI = async (query: string) => {
    if (query.length >= 2) {
      const tempArray: string[] = [];
      const workspaceRecruiterSuggestions = await usersAdvanceFilterQuery(query);
      workspaceRecruiterSuggestions.data.map((data) => tempArray.push(data?.userId));
      setSuggestionData(tempArray);
    }
  };
  const onSaveHandler = async (data: FieldValues) => {
    if (!isEmpty(sEmail)) {
      try {
        const tempData = tableData;
        if (!tempData.jobBoardSearchAccountUsers) {
          tempData.jobBoardSearchAccountUsers = [];
        }

        const userAccount: JobBoardShareAccount = {
          email: sEmail,
          country: (country ?? '').toUpperCase(),
          maxQueries: data.credits,
        };
        const sData: IJobBoardShareAccountPayload = {
          accountId: tableData.id,
          account: userAccount,
          deletedUser: [],
        };
        try {
          await shareJobBoardAccounts(sData);
          tempData.jobBoardSearchAccountUsers?.push(userAccount);
          dataUpdater({ ...tempData }, dataIndex);
          reset();
          setNotification(success('Account shared Successfully!'));
          onClose();
        } catch {
          setNotification(failed('Unable to share Account!'));
        }
      } catch (error) {
        setNotification(failed('Unable to share Account!'));
      }
    } else {
      setNotification(failed('Please enter workspace email!'));
    }
  };

  return (
    <Box>
      <FormProvider {...methods}>
        <Grid spacing={1} container mb={2}>
          <Grid item xs={5}>
            <BoldLabel sx={{ mb: 0.5 }}>Share with *</BoldLabel>
            <WsAutoComplete
              onValueEnter={workspaceRecruiterSearchAPI}
              onTagsChange={onEmailSelect}
              placeholder="workspace user email"
              initialValue={[]}
              optionsInStringArray={suggestionsData}
              multiple={false}
              freeSolo={false}
              name="workspaceRecruiterSearch"
              size="small"
              required={true}
              variant="outlined"
            />
          </Grid>
          <Grid item xs={4}>
            <ControlledTextInput
              name="credits"
              labelText="Views/Day*:"
              type="number"
              fullWidth
              id="credits"
              placeholder="credits"
              variant="outlined"
              required
              size="small"
              inputProps={{ style: { padding: '8.2px' } }}
              sx={{ pt: 0.6 }}
            />
          </Grid>
          <Grid item xs={3} display={'flex'} justifyContent={'end'} direction="column">
            <WsButton
              type="submit"
              onClick={handleSubmit(onSaveHandler)}
              variant="outlined"
              size="large"
            >
              Share Credits
            </WsButton>
          </Grid>
        </Grid>
      </FormProvider>
    </Box>
  );
};

export default ShareQuota;
